"use client";

import { useEffect } from "react";

import { addMessages, resetChat } from "@/context/redux/reducers/chat-slice";
import { useAppDispatch, useAppSelector } from "@/hooks/redux-hooks";
import { useLang } from "@/hooks/use-lang";

import { getPresetSessionMap } from "../data/preset-session-map";
import { MessageComponent } from "./message-widgets/MessageComponent";

const ChatMessage = () => {
  const { t } = useLang();
  const { messages } = useAppSelector((state) => state.chat);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const session = getPresetSessionMap({ t }).default;
    dispatch(resetChat());
    dispatch(addMessages(session));
  }, [dispatch, t]);

  return <MessageComponent session={messages} />;
};

export default ChatMessage;
